import Intro from "../../../../src/components/ratelimit-p2/intro";
import Resources from "../../../../src/components/ratelimit-p2/resources";
import * as React from 'react';
export default {
  Intro,
  Resources,
  React
};